/*
 * @Description: Resource Owner Password Credentials Flow
 * @Author: sharebravery
 * @Date: 2023-06-05 16:17:41
 */
export const oidcPasswordFlowSetting = {
  grant_type: 'password',
  username: '',
  password: '',
  client_id: 'action_learning_main',
  client_secret: 'E048F5FE7C3FCC909416813D7C4C0F0D',
  scope: 'api offline_access',
  refresh_token: '',
};
